module.exports = __webpack_public_path__ + "static/img/technologybimg3.983394c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coreValues/technologybimg3.jpg
// module id = 0uqT
// module chunks = 2